<template>
  <div>
    <div class="sjlist" style="padding-bottom: 20px;width:1196px;">
      <ul style="list-style:none; margin-top:20px;">
        <li style="margin-left:0px" v-for="(item,index) in data">
          <!--<a href="javascript:if(confirm(&#39;http://wpa.qq.com/msgrd?v=3&amp;uin=70915355&amp;site=qq&amp;menu=yes&#39;))window.location=&#39;http://wpa.qq.com/msgrd?v=3&amp;uin=70915355&amp;site=qq&amp;menu=yes&#39;"-->
            <!--title="点击对话" target="_blank">-->
            <div class="businessItem">
              <div class="atitle">{{item.topic}}</div>
              <div class="aqq">QQ：{{item.qq}}</div>
              <div class="aqq">微信：{{item.weixin}}</div>
              <div class="amemo"></div>
            </div>
          <!--</a>-->
        </li>

      </ul>
      <div class="clearBoth"></div>
    </div>
  </div>
</template>
<script>
  import {mapState, mapGetters, mapActions} from 'vuex'

  export default {
    computed: {
      ...mapState('home', ['data']),
    },
    components: {},
    data() {
      return {
        parentSlidePics: [],
      };
    },
    mounted() {},
    methods: {
      ...mapActions('home', ['businessList']),
    },
    created() {
      this.businessList()
      console.log("切换页面")
    }
  }
</script>
<style lang="less" scoped>
  @import url(../assets/css/businessList.less);
</style>
<style lang="less">
  .sjlist {
    width: 1176px;
    margin: 0 auto;
    height: auto;
    border: 2px solid #ccc;
    margin-top: 10px;
    border-radius: 10px;
    padding-left: 10px;
    padding-right: 10px;
  }

  .sjlist li {
    float: left;
    margin-left: 14px;
    margin-bottom: 10px;
  }

  .atitle {
    padding-top: 45px;
    margin: 0px auto;
    width: 282px;
    font-size: 36px;
    padding-left: 10px;
    color: white;
  }

  .aqq {
    margin: 0px auto;
    width: 282px;
    font-size: 18px;
    font-weight: bold;
    color: white;
    padding-left: 10px;
  }

  .amemo {
    padding-top: 5px;
    margin: 0px auto;
    width: 282px;
    text-align: center;
    font-size: 14px;
  }

  a {
    text-decoration: none
  }

  .first img {
    border: 0
  }

  .login {
    width: 100%;
    height: 330px;
    margin: 0 auto;
    padding-top: 10px
  }

  .login_l {
    width: 280px;
    height: 330px;
    float: left;
    border: #dedede solid 1px;
    margin-right: 14px
  }

  .danyuan {
    margin: 0 auto;
    padding: 5px;
    width: 260px;
    overflow: hidden;
    margin-top: 10px
  }

  .danyuan tr td {
    height: 50px
  }

  .inp_IndexLogin {
    border: 1px #d3d3d3 solid;
    border-right: 1px #eaeaea solid;
    border-bottom: 1px #eaeaea solid;
    padding: 8px;
    font-size: 14px;
    width: 180px
  }

  .inp_IndexLoginbtn {
    width: 98px;
    height: 31px;
    border: 0;
    vertical-align: middle;
    margin-right: 20px;
    cursor: pointer;
    margin-top: 5px
  }

  .login_r {
    width: 900px;
    height: 330px;
    float: left;
    position: relative
  }

  .login_r ul li {
    position: absolute;
    top: 0
  }

  .gonggao {
    width: 100%;
    height: 400px;
    margin: 0 auto;
    padding-top: 20px
  }

  .gonggao_l {
    width: 280px;
    height: 340px;
    float: left;
    border: #dedede solid 1px;
    margin-right: 18px;
    margin-top: 45px;
    padding-top: 10px
  }

  .ulcommon {
    text-align: center
  }

  .ulcommon li {
    margin-bottom: 12px;
    margin-top: 12px
  }

  .fnb {
    margin-right: 10px;
    background: #fa6d0d;
    display: inline-block;
    width: 20px;
    height: 20px;
    color: #fff;
    text-align: center
  }

  .fnb1 {
    margin-right: 10px;
    background: #cdcdcd;
    display: inline-block;
    width: 20px;
    height: 20px;
    color: #fff;
    text-align: center
  }

  .ulcommon li a {
    font-size: 14px;
    color: #000
  }

  .ulcommon li a:hover {
    text-decoration: none;
    color: #056faa
  }

  .nc a {
    color: #333;
    text-decoration: none
  }

  .nc a:hover {
    text-decoration: none;
    color: #056faa
  }

  .gonggao_r {
    width: 890px;
    height: 396px;
    float: left;
    position: relative;
    z-index: 1
  }

  .title_z {
    height: 260px;
    width: 890px;
    text-align: center
  }

  .z_today {
    width: 420px;
    margin-top: 50px
  }

  .z_day {
    width: 420px;
    float: right;
    margin-top: -155px
  }

  .title_top {
    position: absolute;
    left: 1px;
    bottom: 0;
    z-index: 2
  }

  .jiangpin {
    width: 100%;
    margin: 0 auto;
    text-align: left;
    overflow: hidden
  }

  .game_index {
    height: 30px;
    line-height: 27px;
    border-bottom: 1px solid #e7e7e7;
    position: relative;
    z-index: 100;
    width: 100%;
    margin-top: 10px
  }

  .game_index .t {
    display: block;
    float: left;
    border-bottom: 4px solid #df2a2a;
    font-size: 22px;
    font-family: "微软雅黑";
    font-weight: bold;
    color: #333
  }

  .game_index .more {
    display: block;
    float: right;
    color: gray;
    cursor: pointer;
    text-decoration: none
  }

  .teacherPic {
    width: 100%;
    overflow: hidden;
    margin: 0 auto
  }

  .teacherPic .content {
    width: 292px;
    height: 140px;
    float: left;
    position: relative;
    overflow: hidden;
    margin: 10px 10px 0 0
  }

  .teacherPic .content img {
    width: 292px;
    height: auto
  }

  .teacherPic .content .txt {
    width: 292px;
    height: 70px;
    background: rgba(18, 21, 44, 0.7);
    position: absolute;
    left: 0;
    bottom: 0;
    padding: 0 5px
  }

  .teacherPic .content .txt h3 {
    color: #fff;
    font-size: 16px;
    font-weight: 100;
    margin: 5px 0 6px 0
  }

  .teacherPic h4 {
    color: #fff;
    font-size: 12px;
    font-weight: 100;
    height: 20px
  }

  .teacherPic .content .txt p {
    color: #fff;
    margin-top: 8px;
    padding-top: 12px
  }

  .content .demo-btn {
    margin-left: 110px;
    margin-top: 10px;
    display: block;
    width: 104px;
    height: 35px;
    line-height: 35px;
    background: #ff9f00;
    border-radius: 4px;
    color: #fff;
    text-decoration: none;
    font-size: 16px;
    text-align: center
  }

  .tri2 {
    width: 0;
    height: 0;
    border-bottom: 7px solid transparent;
    border-top: 8px solid transparent;
    border-left: 8px solid #fff;
    font-size: 0;
    line-height: 0;
    vertical-align: middle;
    margin-left: 8px
  }

  .gonggao5 {
    width: 100%;
    height: 330px;
    margin: 0 auto;
    padding-top: 20px
  }

  .jiangpin_r {
    width: 900px;
    height: 320px;
    float: left;
    position: relative;
    z-index: 1
  }

  .title_index {
    height: 30px;
    line-height: 27px;
    border-bottom: 1px solid #e7e7e7;
    position: relative;
    z-index: 100;
    width: 890px;
    margin-top: 10px
  }

  .title_index .t {
    display: block;
    float: left;
    border-bottom: 4px solid #df2a2a;
    font-size: 22px;
    font-family: "微软雅黑";
    font-weight: bold;
    color: #333
  }

  .title_index .more {
    display: block;
    float: right;
    color: gray;
    cursor: pointer;
    text-decoration: none
  }

  .cont .ul_1 {
    display: block;
    overflow: hidden;
    margin: 20px 0 20px 0
  }

  .cont .ul_1 li {
    display: block;
    float: left;
    text-align: center;
    margin-right: 10px
  }

  .cont .ul_1 li a {
    cursor: pointer
  }

  a:link, a:visited, a:active {
    text-decoration: none
  }

  .cont .ul_1 li img {
    width: 290px;
    height: 170px;
    border: 0
  }

  .cont .ul_1 li a p {
    line-height: 30px;
    line-height: 30px;
    margin-bottom: 10px;
    margin-top: 10px;
    font-size: 18px;
    color: #000
  }

  .kefu {
    width: 280px;
    height: 326px;
    float: left;
    border: #dedede solid 1px;
    margin-right: 18px
  }

  .ulcommon {
    text-align: center
  }

  .ulcommon li {
    margin-bottom: 12px;
    margin-top: 12px
  }

  .fnb {
    margin-right: 10px;
    background: #fa6d0d;
    display: inline-block;
    width: 20px;
    height: 20px;
    color: #fff
  }

  .fnb1 {
    margin-right: 10px;
    background: #cdcdcd;
    display: inline-block;
    width: 20px;
    height: 20px;
    color: #fff
  }

  .ulcommon li a {
    font-size: 14px;
    color: #000
  }

  .ul_qqservice {
    margin-top: 25px;
    padding: 0
  }

  .ul_qqservice li {
    margin-bottom: 10px;
    margin-left: 40px
  }

  .youqing {
    width: 100%;
    margin: 0 auto;
    text-align: left;
    margin-top: 10px
  }

  .youqing_index {
    height: 30px;
    line-height: 27px;
    border-bottom: 1px solid #e7e7e7;
    position: relative;
    z-index: 100;
    width: 100%;
    margin-top: 10px
  }

  .youqing_index .t {
    display: block;
    float: left;
    border-bottom: 4px solid #df2a2a;
    font-size: 22px;
    font-family: "΢���ź�";
    font-weight: bold;
    color: #333
  }

  .youqing_index .more {
    display: block;
    float: right;
    color: gray;
    cursor: pointer;
    text-decoration: none
  }

  .hpright h1 {
    line-height: 50px;
    text-indent: 8px
  }

  .hd .hdli {
    margin-bottom: 20px;
    background: #fff;
    border: #ddd solid 1px;
    overflow: auto;
    zoom: 1
  }

  .jinxingzhong {
    text-align: center
  }

  .jinxingzhong_1 {
    background: #ff762f;
    color: #fff;
    line-height: 42px;
    font-size: 20px;
    text-indent: 8px
  }

  .jieshu {
    text-align: center
  }

  .jieshu_1 {
    line-height: 40px;
    font-size: 20px;
    border-bottom: 1px solid #ff762f;
    text-indent: 8px;
    background: #fff;
    color: #ff762f;
    border-right: 2px solid #e7e7e7;
    border-top: 2px solid #e7e7e7;
    border-left: 2px solid #e7e7e7
  }

  .hd .hdpic {
    float: left;
    border: 1px solid #ccc;
    padding: 2px
  }

  .hd ul {
    margin-left: 300px;
    width: 650px;
    height: 154px;
    overflow: hidden
  }

  .hd .n1 {
    color: #ff762f;
    font-weight: bold;
    font-size: 16px
  }

  .hd ul li {
    line-height: 34px
  }

  .page {
    margin-bottom: 10px;
    text-align: center;
    clear: both;
    padding-top: 10px
  }

  .page a {
    font-size: 14px;
    color: #000;
    padding: 3px 6px;
    border: #ccc solid 1px;
    background: #fff;
    margin: 0 5px
  }

  .Vip {
    width: 100%;
    height: auto;
    margin: 0 auto;
    margin-top: 10px;
    clear: both;
    overflow: hidden;
  }

  .Vip_left {
    width: 20%;
    float: left
  }

  .huiyuanzhongxin {
    height: 45px;
    font-size: 20px;
    color: #fff;
    text-align: center
  }

  .Vip_right {
    width: 80%;
    float: right
  }

.zhanghuxinxi{width:100%;text-align:left;height:43px;line-height:40px;position:relative;
background-color: #1b9af7;border-left:5px solid #5ebbff;}

  .zhanghuxinxi .t {
    display: block;
    float: left;
    margin-left: 20px;
    height: 40px;
    line-height: 40px;
    margin-bottom: -3px;
    font-size: 18px;
    font-family: "微软雅黑";
    font-weight: bold;
    color: #fff
  }

  .zhanghuxinxi .t_right {
    float: right;
    margin-right: 10px;
    color: #333
  }

  .zhanghuxinxi .t_right a {
    text-decoration: none;
    color: #999
  }

  .vipdengji {
    text-align: center;
    line-height: 39px;
    width: 950px;
    margin-left: -2px
  }

  .vipdengji td {
    border-left: 1px solid #e7e7e7;
    border-bottom: 1px solid #e7e7e7;
    height: 39px;
    padding-left: 5px
  }

  .zhaq {
    width: 950px;
    height: 290px;
    border: 1px solid #efefef;
    float: left
  }

  .zhaq_t {
    font-family: "微软雅黑";
    font-size: 20px;
    font-weight: bold;
    text-align: left
  }

  .tasklist {
    height: 120px;
    width: 100%;
    border: 1px solid #e7e7e7;
  }

  .tasklist th.pass {
    color: #390
  }

  .tasklist td.pass {
    color: #350
  }

  .tasklist td a {
    color: #1b9af7
  }

  .tasklist th {
    font-weight: normal;
    border-bottom: 1px solid #eee;
    height: 30px;
    line-height: 30px;
    color: black;
    text-align: left;
    padding-left: 2px;
  }

  .icon-pass {
    width: 20px;
    height: 20px;
    display: inline-block;
    vertical-align: middle
  }

  .icon-hand {
    width: 20px;
    height: 20px;
    display: inline-block;
    vertical-align: middle
  }

  .tasklist td {
    padding-left: 5px;
    color: #999;
    border-bottom: 1px solid #eee
  }

  .icon-wrong {
    width: 20px;
    height: 20px;
    display: inline-block;
    vertical-align: middle
  }

  a:link, a:visited {
    text-decoration: none
  }

  .jinqi {
    width: 950px;
    height: 290px;
    border: 2px solid #efefef;
    float: right
  }

  .taskjinqi {
    height: auto;
    width: 100%;
    border: 1px solid #e7e7e7;
  }

  .taskjinqi td {
    padding: 5px;
    padding-left: 10px;
    color: #666;
    border-bottom: 1px solid #eee;
    height: 30px
  }

  .taskjinqi td a {
    color: #666;
    text-decoration: none
  }

  .taskjinqi td a:hover {
    color: #3299ff
  }

  .zhdt1 {
    float: right;
    position: relative;
    height: 30px;
    line-height: 27px;
    border-bottom: 1px solid #e7e7e7;
    z-index: 100;
    width: 950px;
    margin-top: 10px
  }

  .zhdt1 .t {
    display: block;
    float: left;
    border-bottom: 4px solid #df2a2a;
    font-size: 22px;
    font-family: "΢���ź�";
    font-weight: bold;
    color: #969696
  }

  .zhdt1 .more {
    display: block;
    float: right;
    color: gray;
    cursor: pointer;
    margin-right: 15px
  }

  .zhdt {
    height: auto
  }

  .zhdt ul {
    border: #e7e7e7 solid 1px;
    width: 100%;
    float: left;
    height: 38px;
    border-top: 0;
    background: #FFF;
    border-right: navy;
    border-left: navy
  }

  .zhdt ul .li1 {
    float: left;
    width: 380px
  }

  .zhdt ul .li2 {
    float: left;
    width: 150px
  }

  .zhdt ul li {
    width: 116px;
    color: #666;
    float: left;
    text-align: left;
    font: 14px/30px 'microsoft yahei'
  }

  .page .current {
    border: 1px solid #f16e00;
    padding: 5px 10px;
    font-weight: bold;
    color: #fff;
    background-color: #f16e00;
    margin-right: 2px
  }

  .Vip_right .info {
    padding-left: 26px;
    color: #1b9af7;
    line-height: 45px;
    height: 45px
  }

  .Vip_right input {
    padding-left: 5px;
    min-height: 24px;
    line-height: 36px;
    margin-bottom: 5px;
    vertical-align: middle;
  }

  .Vip_right select {
    height: 25px;
    line-height: 25px;
    width: 100px;
    margin-bottom: 5px
  }

  .usertbtable .td1 {
    text-align: right
  }

  .usertbtable tr td {
    padding: 5px 0
  }

  .usertbtable .td2 input {
    width: 300px;
    height: 30px;
    line-height: 30px;
    text-indent: 4px
  }

  .receivebadge2 {
    font-size: 14px;
    font-family: "微软雅黑";
    line-height: 30px;
    padding: 20px 20px 10px 150px;
    clear: both;
    overflow: auto
  }

  .gettable {
    width: 100%;
    line-height: 30px;
    text-align: center
  }

  .gettable td a {
    color: #f86300
  }

  .gettable td a:hover {
    text-decoration: none;
    color: #056faa
  }

  .gonggaozhongxin {
    width: 100%;
    height: auto;
    margin: 0 auto;
    margin-top: 10px
  }

  .ulcommon {
    text-align: left;
    margin-left: 20px
  }

  .Coinfont3 {
    font-family: Arial, Helvetica, sans-serif;
    color: #f60;
    font-size: 14px;
    font-weight: bold;
    padding: 0 18px 0 0;
    margin: 0 auto
  }

  .gonggaozhongxin_boom {
    width: 280px;
    height: 300px
  }

  .gonggaozhongxin_right {
    width: 900px;
    height: auto;
    margin-bottom: 10px;
    float: left
  }

  .gonggao1 {
    font-size: 20px;
    color: #fff;
    height: 40px;
    line-height: 40px
  }

  .marq {
    width: 284px;
    height: 301px;
    float: right;
    border: #dedede solid 1px;
    margin-right: -287px;
    margin-top: 310px;
    overflow: hidden;
    background: #fff
  }

  .marq_top {
    width: 277px;
    float: right;
    margin-right: 10px
  }

  #tabs {
    width: 100%;
    margin: 0 auto;
    margin-bottom: 10px
  }

  #tabs ul {
    width: 355px;
    background: #fff
  }

  #tabs li {
    float: left;
    margin-right: 2px;
    height: 37px
  }

  #tabs li a {
    display: block;
    padding: 10px 30px;
    text-decoration: none;
    font-weight: bold;
    font-size: 14px
  }

  .tabulous_active {
    background: #ff8530;
    color: #fff;
    font-weight: bold
  }

  .tabulousclear {
    display: block;
    clear: both
  }

  #tabs_container {
    padding: 0 20px 20px 20px;
    overflow: hidden;
    position: relative;
    background: white;
    border: 1px solid #ff8530
  }

  #tabs_container div {
    margin-right: 40px
  }

  .clearBoth {
    clear: both;
    height: 0;
    line-height: 0;
    display: block
  }

  .showscale {
    transform: scale(1);
    opacity: 1;
    -webkit-transition-delay: .3s;
    -moz-transition-delay: .3s;
    -o-transition-delay: .3s;
    -ms-transition-delay: .3s;
    transition-delay: .3s
  }

  .tiyan_L {
    width: 900px;
    height: 325px;
    overflow: hidden;
    position: relative
  }

  #banner_roll {
    width: 900px;
    height: 10000px;
    position: absolute;
    top: 0;
    left: 0
  }

  #banner_roll li {
    float: left;
    width: 900px;
    height: 336px;
    margin: 0;
    padding: 0;
    overflow: hidden
  }

  #banner_roll li, #banner_roll a, #banner_roll a img {
    display: block
  }

  #banner_roll a img {
    width: 900px;
    height: 336px
  }

  #banner_roll_small a:hover, #banner_roll_small a.on {
    border: 2px solid red
  }

  .banner_roll_small_bg {
    background: #000;
    filter: alpha(opacity=70);
    -moz-opacity: .7;
    opacity: .7
  }

  #banner_roll_small, .banner_roll_small_bg {
    width: 100%;
    height: 74px;
    position: absolute;
    top: 250px;
    left: 0
  }

  #banner_roll_small .on {
    display: block
  }

  #banner_roll_small span {
    display: none;
    margin-top: 8px;
    margin-left: 10px;
    float: left;
    color: #fff;
    width: 360px;
    height: 65px
  }

  #banner_roll_small span b {
    font-size: 14px;
    float: left;
    height: 25px;
    line-height: 25px;
    color: #fff
  }

  #banner_roll_small span i {
    overflow: Hidden;
    float: left;
    width: 100%;
    height: 36px;
    line-height: 18px;
    color: #aeaeac
  }

  #banner_roll_small a {
    float: right;
    margin-right: 10px;
    border: 2px #fff solid;
    margin-top: 8px
  }

  #banner_roll_small .i {
    width: 54px;
    height: 54px;
    float: left
  }

  #banner_roll li, #banner_roll a, #banner_roll a img {
    display: block
  }

  .tiyan_R {
    float: right;
    margin-top: -325px
  }

  .clockNum {
    color: #1b9af7;
    font-size: 14px;
    font-weight: bold;
    font-family: Verdana, Arial, Helvetica, sans-serif
  }

  .xhx {
    border-bottom: 1px dotted #000
  }

  .profittb tr td {
    padding-top: 4px;
    padding-bottom: 4px;
    padding-right: 10px
  }

  .gtable tr td a:hover {
    text-decoration: none
  }

  .dhjp {
    width: 100%;
    height: auto;
    margin: 0 auto;
    margin-top: 10px;
    clear: both;
    overflow: auto
  }

  .dhjp_left {
    width: 250px;
    height: auto;
    float: left;
    clear: both;
    overflow: auto
  }

  .duihuanjiangpin1 {
    height: 45px;
    font-size: 25px;
    font-family: "微软雅黑";
    font-weight: bold;
    color: #fff;
    text-align: center;
    margin-top: 10px
  }

  .dhjp_right {
    width: 940px;
    height: auto;
    float: right
  }

  .right_top {
    width: 938px;
    height: 275px;
    border: 1px solid #e2e2e2
  }

  .top_table {
    border-collapse: collapse
  }

  .top_table td {
    border-bottom: solid 1px #e2e2e2;
    border-right: solid 1px #e2e2e2
  }

  .top_table td a img {
    border: 0
  }

  .top_table td a:hover img {
    color: #f60;
    border: 2px solid #3c98e1
  }

  .right_boom {
    width: 940px;
    height: auto;
    margin-top: 10px;
    border: 0
  }

  .m-filterForm {
    height: 39px;
    color: #6d6d6d;
    background-color: #f5f5f5;
    border: solid 1px #e8e8e8
  }

  .m-filterForm .sorts {
    float: left;
    line-height: 39px
  }

  .m-filterForm .sorts .active {
    border-right: solid 1px #e8e8e8;
    background-color: #fff;
    color: #f40;
    cursor: default
  }

  .m-filterForm .sorts .item {
    float: left;
    _display: inline;
    padding: 0 19px;
    cursor: pointer
  }

  .m-filterForm .prices {
    float: left;
    width: 146px;
    height: 39px
  }

  .m-filterForm .prices .inner {
    position: absolute;
    padding: 1px 9px;
    height: 37px;
    -webkit-transition: background .1s linear;
    -moz-transition: background .1s linear;
    -ms-transition: background .1s linear;
    -o-transition: background .1s linear;
    transition: background .1s linear
  }

  .m-filterForm .prices .items {
    overflow: hidden;
    height: 23px;
    margin-top: 6px
  }

  .m-filterForm .prices .item {
    position: relative;
    float: left;
    _display: inline;
    width: 58px;
    height: 23px
  }

  .ks-chrome .m-filterForm .prices .input {
    line-height: normal
  }

  .m-filterForm .prices .input {
    position: absolute;
    width: 40px;
    padding-left: 16px;
    height: 21px;
    border: solid 1px #dfdfdf;
    line-height: 21px
  }

  .m-filterForm .prices .icon {
    position: absolute;
    font-family: arial;
    line-height: 25px;
    width: 16px;
    text-align: center;
    color: #999
  }

  .m-filterForm .prices .sep {
    width: 10px;
    line-height: 23px;
    text-align: center;
    color: #999
  }

  .m-filterForm .page12 {
    float: left;
    margin-left: 260px;
    height: 39px;
    width: 39px
  }

  .m-filterForm .page13 {
    height: 39px;
    width: 39px;
    float: left;
    margin-left: 5px
  }

  .m-filterForm .page {
    float: right;
    margin-top: 10px;
    height: 39px
  }

  .m-filterForm .page .item {
    float: left;
    width: 40px;
    text-align: center
  }

  .m-filterForm .page .num {
    color: #f40
  }

  .product {
    width: 928px;
    float: right;
    border-top: navy;
    margin-top: 0;
    padding: 0;
    border: #e8e8e8 solid 1px
  }

  .ul_cp li {
    width: 280px;
    float: left;
    text-align: left;
    padding: 2px 3.4px 2px 0;
    border-left: #e8e8e8 solid 1px;
    border: #e8e8e8 solid 1px;
    text-align: center;
    margin: 10px 12px
  }

  .ul_cp li a {
    text-decoration: none
  }

  .ul_cp li p {
    margin-left: 15px;
    color: black
  }

  .ul_cp li img {
    border: 0
  }

  .cp_page .item {
    float: left;
    margin-left: -1px;
    width: 35px;
    border: solid 1px #ededed;
    color: #3e3e3e;
    text-align: center;
    line-height: 35px;
    font-weight: 700;
    cursor: pointer
  }

  .cp_page .active, .cp_page .active:hover {
    position: relative;
    background: darkorange;
    color: #fff;
    border-color: darkorange;
    cursor: default;
    text-decoration: none
  }

  .cp_page .total {
    color: #a6a6a6;
    margin-right: -80px;
    margin-top: -15px;
    float: right
  }

  .notice {
    width: 100%;
    height: 600px;
    margin: 0 auto;
    margin-top: 20px;
    margin-bottom: 20px
  }

  .notice_l {
    width: 280px;
    height: 600px;
    border: 1px solid #e6e6e6;
    margin-right: 30px
  }

  .notice_top {
    margin-top: 20px;
    text-align: center
  }

  .c_right {
    width: 260px;
    margin-left: 10px;
    height: 60px;
    border-bottom: 1px dashed #e5e5e5;
    line-height: 30px;
    color: #999
  }

  .notice_l ul li a {
    cursor: pointer;
    display: block
  }

  .notice_l ul li a a:hover {
    background-color: yellow;
    color: #fff
  }

  .pages {
    text-align: center;
    margin-top: 30px
  }

  .notice_r {
    width: 880px;
    height: 600px;
    border: 2px solid #fa6e0e;
    float: right;
    margin-top: -605px
  }

  .notice_content {
    width: 700px;
    height: 400px;
    margin: 0 auto;
    margin-top: 70px
  }

  .notice_zi {
    line-height: 40px;
    margin-left: 20px
  }

  .gonggaozhongxin_boom img {
    border: 0
  }

  .notice {
    width: 100%;
    height: auto;
    margin: 0 auto;
    margin-top: 10px;
    margin-bottom: 10px;
    -moz-border-radius: 5px;
    -webkit-border-radius: 5px;
    border-radius: 5px
  }

  .notice_img {
    text-align: center;
    margin-top: 15px;
    margin-bottom: 15px
  }

  .notice_center {
    width: 1110px;
    margin: 0 auto
  }

  .notice_center li {
    height: 60px;
    line-height: 60px;
    border-bottom: 1px solid #1b9af7;
    font-size: 14px;
    font-family: "微软雅黑";
    color: black
  }

  .notice_center li a {
    font-size: 14px;
    font-family: "微软雅黑";
    color: #333;
    text-decoration: none
  }

  .notice_center li a:hover {
    color: #3299ff
  }

  .notice_center li span {
    float: right;
    width: 200px
  }

  .notice_page {
    margin-bottom: 10px;
    text-align: center;
    clear: both;
    padding-top: 35px
  }

  .notice_page a {
    font-size: 14px;
    color: #000;
    padding: 3px 6px;
    border: #ccc solid 1px;
    background: #fff;
    margin: 0 5px
  }

  .help {
    width: 100%;
    margin: 0 auto;
    height: auto;
    margin-top: 10px
  }

  .help_l {
    width: 280px;
    float: left;
    border: #dedede solid 1px;
    margin-right: 10px
  }

  .help_r {
    width: 900px;
    float: right;
    border: #dedede solid 1px
  }

  .help_title {
    width: 902px;
    height: 55px;
    background: #1b9af7;
    margin-left: -1px
  }

  .help_c {
    width: 100%
  }

  .help_c li {
    width: 850px;
    margin: 0 auto;
    border-top: #dedede dashed 1px;
    line-height: 50px;
    font-size: 16px;
    font-weight: normal
  }

  .help_c li a {
    text-decoration: none;
    color: #000
  }

  .hptit {
    display: none
  }

  .hpcon {
    display: none;
    font-size: 12px;
    line-height: 25px
  }

  .li_cls {
    cursor: pointer
  }

  .zxnb_h_l {
    width: 530px;
    float: left;
  }

  .zxnb_h_r {
    width: 408px;
    float: right;
  }
</style>



// WEBPACK FOOTER //
// src/pages/businessList.vue